export default [
  { value: 'hotels', title: 'Отели' },
  { value: 'guides', title: 'Гиды' },
  { value: 'culturalOrganizations', title: 'Организации культуры' },
  { value: 'touristAgencies', title: 'Тур. операторы/агентства' },
  { value: 'eventOrganizers', title: 'Организаторы мероприятий' },
  { value: 'routes', title: 'Маршруты' },
  { value: 'events', title: 'События' },
  { value: 'audioguides', title: 'Аудиогиды' },
  { value: 'sharedAccess', title: 'Общий доступ' },
  { value: 'ticketReservations', title: 'Продажи' }
]
